const Sections = {
    Inbox: 'inbox',
    JobOffer: 'job_offer',
    PushOffer: 'push_offer',
    PullConfig: 'pull_config',
    SavedSearches: 'saved_searches',
    Planning: 'planning',
    Favorites: 'favorites',
    Reports: 'reports',
    StatisticsDashboard: 'statistics_dashboard',
    JobflowEvaluation: 'jobflow_evaluation',
    Multiposting: 'multiposting',
    RPAConfig: 'rpa_config',
    EvaluativeTests: 'evaluative_tests',
    GPPRequestor: 'template_requestor',
    GPPValidator: 'template_validator',
    GIPPRequestor: 'gipp_template_requestor',
    GIPPValidator: 'gipp_template_validator',
};

const BasicUserSections = [
    Sections.Inbox,
    Sections.JobOffer,
    Sections.PushOffer,
    Sections.PullConfig,
    Sections.SavedSearches,
    Sections.Planning,
    Sections.Favorites,
    Sections.Reports,
    Sections.StatisticsDashboard,
    Sections.JobflowEvaluation,
    Sections.Multiposting,
    Sections.RPAConfig,
    Sections.EvaluativeTests,
    Sections.GPPRequestor,
    Sections.GPPValidator,
    Sections.GIPPRequestor,
    Sections.GIPPValidator,
];

const AtsAdminUserSections = [
    Sections.JobflowEvaluation,
    Sections.Multiposting,
    Sections.EvaluativeTests,
];


export { Sections, BasicUserSections, AtsAdminUserSections }